import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { init as mainTheme } from './themes/main';
import { DrillDownWidget as mainModule } from './main';
import * as config from './config';

declare var require: any;
require('../sass-main/pdc-widget-drill-down.sass');

export class DrillDownWidget extends WidgetBase {
    public static _name: string = config.name;
    public static group = config.group;
    public static moduleName: string = config.moduleName;
    public static icon: string = config.icon;
    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-drill-down'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(DrillDownWidget);
